import React, { useEffect, useState } from "react";
import AdminLayout from "../../UI/Layout/AdminLayout";
import Spining from "../../UI/Spining/Spining";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Axios from "../../../axios/Axios";
import { NODE_HOST_URL } from "../../Dashboard/api/Api";
import { userloginDetails } from "../../Utils/AdminAuth";
import EmptyImg from "../../Dashboard/assets/img/create-project.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faSearch } from "@fortawesome/free-solid-svg-icons";
import AdvanceDataTable from "../../UI/Table/AdvanceDataTable";
// import { ADMIN_RCS_REQUEST_LIST } from "../../UI/Table/ColumnConst";

const RcsOnboardingList = () => {
    const lStorage = userloginDetails();
    const userId = lStorage?.user?.userId;
    const userToken = lStorage?.token;
    const [loading, setLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const [searchData, setSearchData] = useState('')

    useEffect(() => {
        fetchRcsOnboardingList();
    }, []);

    const handleStaus = async (e, id) => {
        setLoading(true);
        let status = parseInt(e.target.value)
        let paramData = {
            user_id: userId,
            token: userToken,
            method: "onboarding_update_status",
            id: id,
            status: status
        }
        try {
            const { data } = await Axios.post(`${NODE_HOST_URL}/admin/rcs`, paramData);

            if (data.success === true) {
                const updatedData = listData.map((x) => {
                    if (x._id === id) {
                        return { ...x, status }
                    }
                    return x;
                })
                setListData(updatedData);
            }
        } catch (error) {

        }

        setLoading(false);

    }

    const fetchRcsOnboardingList = async () => {
        setLoading(true);
        try {
            const dataForList = {
                user_id: userId,
                token: userToken,
                method: "onboarding_request",
            };
            const { data } = await Axios.post(
                `${NODE_HOST_URL}/admin/rcs`,
                dataForList
            );
            if (data.success === true) {
                setListData(data.data);
            }
        } catch (error) {
            console.log(error.message);
        }
        setLoading(false)
    };

    const ADMIN_RCS_REQUEST_LIST = [
        {
            name: "UID",
            selector: (row) => row.user_id,
            sortable: true,
            width: "80px"
        },
        {
            name: "User Name",
            selector: (row) => row.username,
            sortable: true,
            width: "250px",
        },
        {
            name: "Display Name",
            selector: (row) => row.display_name,
            sortable: true,
            width: "250px",
        },
        {
            name: "Manager Name",
            selector: (row) => row.manager_name,
            sortable: true,
            width: "150px",
        },
        {
            name: "Manager Phone",
            selector: (row) => row.manager_phone,
            sortable: true,
            width: "150px",
        },
        // {
        //     name: "Bot Type",
        //     selector: (row) => row.bot_type,
        //     sortable: true,
        //     width: "150px",
        // },
        {
            name: "Created Date",
            selector: (row) => row.created_date,
            sortable: true,
            width: "200px",
        },
        {
            name: "Status",
            selector: (row) => row.status,
            cell: (row) => (
                <select
                    value={row.status}
                    style={{ color: row.status === 0 ? "orange" : row.status === 1 ? "green" : row.status === 2 ? "blue" : row.status === 3 ? "red" : "black" }}
                    className="form-control m-2 text-align-center"
                    onChange={(e) => handleStaus(e, row._id)}
                >
                    <option style={{ color: "orange" }} value="0">Pending</option>
                    <option style={{ color: "green" }} value="1">Approved</option>
                    <option style={{ color: "blue" }} value="2">In Process</option>
                    <option style={{ color: "red" }} value="3">Rejected</option>
                </select>
            ),
            sortable: true,
            width: "200px",
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <Link
                        to={`/admin/rcs/rcs-request-list-detail/${row._id}`}
                    >
                        <FontAwesomeIcon icon={faEye} style={{ cursor: "pointer", textAlign: "center" }} />
                    </Link>
                </div>
            ),
            sortable: true,
        },
    ];

    return (
        <>
            {loading && <Spining />}
            <AdminLayout>
                <div className="row">
                    <div className="col-3">
                        <h6>Request List</h6>
                    </div>
                </div>

                {listData.length > 0 ?
                    <>
                        {/* <div className='row mb-3'>
                                    <div className='col-12 col-md-6'>
                                        <div className="input-group float-md-right">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text"><FontAwesomeIcon icon={faSearch} /></span>
                                            </div>
                                            <input
                                                type="text"
                                                id="searchInput"
                                                name="searchdata"
                                                value={searchData}
                                                onChange={(e) => setSearchData(e.target.value)}
                                                className="form-control"
                                                placeholder="Search"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-striped table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="d-xl-table-cell">User ID</th>
                                                <th className="d-xl-table-cell">Display Name</th>
                                                <th className="d-md-table-cell">Manager Name</th>
                                                <th className="d-md-table-cell">Manager Phone</th>
                                                <th className="d-md-table-cell">Bot Type</th>
                                                <th className="d-md-table-cell">Created Date</th>
                                                <th className="d-md-table-cell">View</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {listData
                                                .filter((x) => {
                                                    return searchData.toLowerCase() === '' ? x : x.display_name.toLowerCase().includes(searchData);
                                                })
                                                .map((item, i) => (
                                                    <tr key={i}>
                                                        <td className="text-start">{item.user_id}</td>
                                                        <td className="text-start">{item.display_name}</td>
                                                        <td className="text-start">{item.manager_name}</td>
                                                        <td className="text-start">{item.manager_phone}</td>
                                                        <td className="text-start">{item.bot_type}</td>
                                                        <td className="text-start">{item.created_date}</td>
                                                        <td style={{ cursor: "pointer" , textAlign:"center"}}><Link target="_blank" to={`/admin/rcs/rcs-request-list-detail/${item._id}`}><FontAwesomeIcon icon={faEye} /></Link></td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>
                                </div> */}

                        <AdvanceDataTable
                            tableCell={ADMIN_RCS_REQUEST_LIST}
                            tableData={listData}
                            isLoading={loading}
                            pagination={true}
                        />
                    </> :
                    <div className="card">
                        <div className="card-body">
                            <div className="text-center">
                                <div className="card-body">
                                    <img alt="Empty Data" className="project-empty-img" src={EmptyImg} />
                                    <p>No Data Yet</p>
                                </div>
                            </div>                    </div>
                    </div>}

            </AdminLayout>
        </>
    );
};

export default RcsOnboardingList;